import React, { useState, useEffect } from 'react';

const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE',
 bg:'#0A1628', surface:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 amber:'#D4840F', amberBg:'rgba(245,158,11,.1)', amberBorder:'#F0D499',
 red:'#EF4444', redBg:'rgba(239,68,68,.1)', redBorder:'#F0B8B8',
 blue:'#FFFFFF', blueBg:'#EAF1FB', blueBorder:'#B8D0F0',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 teal:'#1A7A7A', tealBg:'#E7F5F5',
 dark:'#0F1E14',
};

const inr = n => '₹' + Number(Math.round(n)||0).toLocaleString('en-IN');

// ─── DEFAULT GST CONFIG (editable) ───────────────────────────────────────────
export const DEFAULT_GST_CONFIG = {
 rooms: [
 { id:'r0', label:'Room Tariff Below ₹1,000/night', minRate:0, maxRate:999, cgst:0, sgst:0, igst:0, note:'Exempt from GST', color:'#7A9A80' },
 { id:'r1', label:'Room Tariff ₹1,000 – ₹7,499/night', minRate:1000, maxRate:7499, cgst:6, sgst:6, igst:12, note:'Total 12% GST', color:'#2563A8' },
 { id:'r2', label:'Room Tariff ₹7,500 and above/night', minRate:7500, maxRate:999999,cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 ],
 fnb: [
 { id:'f1', label:'Restaurant (AC)', cgst:2.5, sgst:2.5, igst:5, note:'Total 5% GST — AC restaurant', color:'#3AAF58' },
 { id:'f2', label:'Restaurant (Non-AC)', cgst:2.5, sgst:2.5, igst:5, note:'Total 5% GST — Non-AC', color:'#3AAF58' },
 { id:'f3', label:'Room Service / In-room Dining', cgst:2.5, sgst:2.5, igst:5, note:'Total 5% GST', color:'#3AAF58' },
 { id:'f4', label:'Outdoor Catering / Banquet F&B', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'f5', label:'Alcoholic Beverages', cgst:14, sgst:14, igst:28, note:'Total 28% GST', color:'#6B48A8' },
 { id:'f6', label:'Non-Alcoholic Beverages', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#D4840F' },
 ],
 events: [
 { id:'e1', label:'Banquet Hall / Venue Rental (₹7,500/day)', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'e2', label:'Banquet Hall / Venue Rental (>₹7,500/day)', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'e3', label:'Wedding Package (Composite)', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'e4', label:'Corporate Day Outing Package', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'e5', label:'School / College Picnic', cgst:2.5, sgst:2.5, igst:5, note:'Total 5% GST', color:'#3AAF58' },
 { id:'e6', label:'Conference / MICE', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 ],
 activities: [
 { id:'a1', label:'Adventure Activities (Outdoor Sports)', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'a2', label:'Spa / Wellness Services', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'a3', label:'Laundry Services', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 ],
 misc: [
 { id:'m1', label:'Transport / Vehicle Hire', cgst:2.5, sgst:2.5, igst:5, note:'Total 5% GST', color:'#3AAF58' },
 { id:'m2', label:'Renting of Immovable Property', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 { id:'m3', label:'Internet / Wi-Fi Services', cgst:9, sgst:9, igst:18, note:'Total 18% GST', color:'#C83333' },
 ],
};

// ─── GST RATE HELPER (use in other modules) ──────────────────────────────────
export function getRoomGST(tariffPerNight, config) {
 const cfg = config || DEFAULT_GST_CONFIG;
 const rule = cfg.rooms.find(r => tariffPerNight >= r.minRate && tariffPerNight <= r.maxRate);
 return rule || cfg.rooms[0];
}

export function getGSTRate(category, subcategory, config) {
 const cfg = config || DEFAULT_GST_CONFIG;
 const allRules = [...cfg.fnb, ...cfg.events, ...cfg.activities, ...cfg.misc];
 return allRules.find(r => r.label === subcategory) || { cgst:9, sgst:9, igst:18 };
}

// ─── ATOMS ───────────────────────────────────────────────────────────────────
const Card = ({children,style={}}) => (
 <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,boxShadow:'0 1px 4px rgba(0,0,0,.05)',...style}}>{children}</div>
);
const SH = ({title,icon,color,bg,right}) => (
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'13px 18px',borderBottom:`1px solid ${C.border}`,background:bg||'#F5F8F5',borderRadius:'12px 12px 0 0'}}>
 <div style={{display:'flex',alignItems:'center',gap:8}}><span style={{fontSize:18}}>{icon}</span><span style={{fontSize:14,fontWeight:700,color:color||C.text}}>{title}</span></div>
 {right}
 </div>
);
const Btn = ({children,onClick,variant='primary',style={},disabled}) => {
 const v={primary:{background:C.accent,color:'#fff',border:'none'},ghost:{background:'transparent',color:C.text2,border:`1px solid ${C.border2}`},amber:{background:C.amberBg,color:C.amber,border:`1px solid ${C.amberBorder}`},danger:{background:C.red,color:'#fff',border:'none'}};
 return <button onClick={onClick} disabled={disabled} style={{...v[variant],padding:'8px 16px',borderRadius:8,fontSize:13,fontWeight:600,cursor:disabled?'not-allowed':'pointer',display:'inline-flex',alignItems:'center',gap:6,...style}}>{children}</button>;
};

const GSTInput = ({value, onChange, label}) => (
 <div style={{textAlign:'center'}}>
 <div style={{fontSize:10,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:4}}>{label}</div>
 <div style={{display:'flex',alignItems:'center',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,overflow:'hidden',width:70}}>
 <input type="number" step="0.5" min="0" max="28" value={value}
 onChange={e=>onChange(parseFloat(e.target.value)||0)}
 style={{flex:1,padding:'7px 4px',border:'none',background:'transparent',fontSize:13,fontWeight:700,fontFamily:'Inter,sans-serif',outline:'none',textAlign:'center',color:C.text}}/>
 <span style={{padding:'7px 6px 7px 0',fontSize:11,color:C.text3}}>%</span>
 </div>
 </div>
);

const SaveToast = ({visible}) => visible ? (
 <div style={{position:'fixed',bottom:28,right:28,background:C.accent,color:'#fff',padding:'12px 20px',borderRadius:12,fontWeight:600,fontSize:14,boxShadow:'0 8px 32px rgba(58,175,88,.4)',zIndex:999,display:'flex',alignItems:'center',gap:8,transition:'all .3s'}}>
 GST Configuration saved!
 </div>
) : null;

// ─── GST CALCULATOR WIDGET ────────────────────────────────────────────────────
function GSTCalculator({config}) {
 const [tariff, setTariff] = useState(8500);
 const [nights, setNights] = useState(1);
 const [rooms, setRooms] = useState(1);
 const [category, setCategory] = useState('Room');
 const [subcategory, setSubcategory] = useState('');
 const [manualGST, setManualGST] = useState(null);
 const [discount, setDiscount] = useState(0);

 // Get applicable GST
 const getApplicableGST = () => {
 if(manualGST !== null) return manualGST;
 if(category === 'Room') {
 const rule = config.rooms.find(r => tariff >= r.minRate && tariff <= r.maxRate);
 return rule ? rule.cgst + rule.sgst : 18;
 }
 const allRules = [...config.fnb,...config.events,...config.activities,...config.misc];
 const rule = allRules.find(r => r.label === subcategory);
 return rule ? rule.cgst + rule.sgst : 18;
 };

 const gstPct = getApplicableGST();
 const roomRule = category === 'Room' ? config.rooms.find(r => tariff >= r.minRate && tariff <= r.maxRate) : null;
 const base = category === 'Room' ? tariff * nights * rooms : tariff;
 const taxable = Math.max(0, base - discount);
 const cgst = Math.round(taxable * (gstPct/2) / 100);
 const sgst = Math.round(taxable * (gstPct/2) / 100);
 const total = taxable + cgst + sgst;

 const cats = {
 Room: [],
 'F&B': config.fnb.map(f=>f.label),
 Events: config.events.map(e=>e.label),
 Activities: config.activities.map(a=>a.label),
 Miscellaneous: config.misc.map(m=>m.label),
 };

 const iStyle = {width:'100%',padding:'9px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,fontFamily:'Inter,sans-serif',outline:'none'};

 return (
 <Card style={{padding:22}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:800,color:C.text,marginBottom:18,display:'flex',alignItems:'center',gap:8}}>
 Live GST Calculator
 <span style={{fontSize:11,fontWeight:400,color:C.text3}}>— applies your configured rates automatically</span>
 </div>

 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:20}}>
 {/* Inputs */}
 <div>
 <div style={{marginBottom:12}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>Service Category</div>
 <select style={iStyle} value={category} onChange={e=>{setCategory(e.target.value);setSubcategory('');setManualGST(null);}}>
 {Object.keys(cats).map(c=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={c}>{c}</option>)}
 </select>
 </div>

 {category !== 'Room' && cats[category].length > 0 && (
 <div style={{marginBottom:12}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>Sub-category</div>
 <select style={iStyle} value={subcategory} onChange={e=>{setSubcategory(e.target.value);setManualGST(null);}}>
 <option style={{background:'#0F2040',color:'#F0F2FF'}} value="">Select sub-category…</option>
 {cats[category].map(c=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={c}>{c}</option>)}
 </select>
 </div>
 )}

 <div style={{marginBottom:12}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>
 {category==='Room'?'Room Tariff / Night':'Base Amount'} (₹)
 </div>
 <input type="number" style={iStyle} value={tariff} onChange={e=>setTariff(Number(e.target.value))}/>
 </div>

 {category==='Room' && (
 <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:12}}>
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>Nights</div>
 <input type="number" min="1" style={iStyle} value={nights} onChange={e=>setNights(Number(e.target.value))}/>
 </div>
 <div>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>Rooms</div>
 <input type="number" min="1" style={iStyle} value={rooms} onChange={e=>setRooms(Number(e.target.value))}/>
 </div>
 </div>
 )}

 <div style={{marginBottom:12}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>Discount (₹)</div>
 <input type="number" min="0" style={iStyle} value={discount} onChange={e=>setDiscount(Number(e.target.value))}/>
 </div>

 <div style={{marginBottom:12}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.05em',marginBottom:5}}>Manual GST Override (%)</div>
 <div style={{display:'flex',gap:8}}>
 {[0,5,12,18,28].map(r=>(
 <button key={r} onClick={()=>setManualGST(manualGST===r?null:r)}
 style={{flex:1,padding:'7px 4px',borderRadius:8,border:`1px solid ${manualGST===r?C.accent:C.border2}`,background:manualGST===r?C.accentLight:'transparent',color:manualGST===r?C.accent:C.text3,fontSize:12,fontWeight:600,cursor:'pointer'}}>
 {r}%
 </button>
 ))}
 </div>
 {manualGST!==null&&<div style={{fontSize:11,color:C.amber,marginTop:4}}> Manual override active — configured rates ignored</div>}
 </div>
 </div>

 {/* Result */}
 <div>
 {/* GST Rule Applied */}
 {category === 'Room' && roomRule && (
 <div style={{background:roomRule.cgst===0?C.accentLight:roomRule.cgst<=6?C.blueBg:C.redBg,border:`1px solid ${roomRule.cgst===0?C.accent:roomRule.cgst<=6?C.blueBorder:C.redBorder}`,borderRadius:10,padding:'14px 16px',marginBottom:14}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:6}}>GST Rule Applied</div>
 <div style={{fontSize:13,fontWeight:700,color:roomRule.color||C.text,marginBottom:4}}>{roomRule.label}</div>
 <div style={{display:'flex',gap:16,fontSize:12}}>
 <span style={{color:C.text3}}>CGST: <strong>{roomRule.cgst}%</strong></span>
 <span style={{color:C.text3}}>SGST: <strong>{roomRule.sgst}%</strong></span>
 <span style={{color:C.text3}}>Total: <strong>{roomRule.cgst+roomRule.sgst}% GST</strong></span>
 </div>
 <div style={{fontSize:11,color:C.text3,marginTop:4}}> {roomRule.note}</div>
 </div>
 )}

 {/* Calculation Breakdown */}
 <div style={{background:C.dark,borderRadius:12,padding:20}}>
 <div style={{fontSize:11,color:'rgba(255,255,255,.4)',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:14}}>GST Calculation Breakdown</div>
 <div style={{display:'flex',flexDirection:'column',gap:8}}>
 {[
 ['Base Amount', category==='Room'?`${inr(tariff)} × ${nights}N × ${rooms} room${rooms>1?'s':''}`:null, inr(base), 'rgba(255,255,255,.7)'],
 discount>0&&['Discount','','-'+inr(discount),'#FF8080'],
 ['Taxable Amount','',inr(taxable),'rgba(255,255,255,.85)'],
 ['CGST','@ '+(gstPct/2)+'%',inr(cgst),'#64B5F6'],
 ['SGST','@ '+(gstPct/2)+'%',inr(sgst),'#64B5F6'],
 ].filter(Boolean).map(([k,s,v,c],i)=>(
 <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 10px',background:'rgba(255,255,255,.05)',borderRadius:8}}>
 <div>
 <div style={{fontSize:13,color:c||'rgba(255,255,255,.7)'}}>{k}</div>
 {s&&<div style={{fontSize:10,color:'rgba(255,255,255,.35)'}}>{s}</div>}
 </div>
 <span style={{fontWeight:700,fontSize:13,color:c||'rgba(255,255,255,.7)'}}>{v}</span>
 </div>
 ))}
 <div style={{borderTop:'1px solid rgba(255,255,255,.1)',paddingTop:10,marginTop:4}}>
 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'10px 12px',background:`rgba(58,175,88,.2)`,borderRadius:10}}>
 <span style={{fontSize:15,fontWeight:800,color:'#fff'}}>Grand Total</span>
 <span style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:24,fontWeight:800,color:C.accent}}>{inr(total)}</span>
 </div>
 </div>
 <div style={{display:'flex',justifyContent:'space-between',padding:'6px 10px',fontSize:12}}>
 <span style={{color:'rgba(255,255,255,.4)'}}>Effective GST Rate</span>
 <span style={{color:'rgba(255,255,255,.7)',fontWeight:700}}>{gstPct}% total ({gstPct/2}% CGST + {gstPct/2}% SGST)</span>
 </div>
 </div>
 </div>
 </div>
 </div>
 </Card>
 );
}

// ─── RATE TABLE EDITOR ────────────────────────────────────────────────────────
function RateTable({title, icon, color, bg, rows, onUpdate, isRoom}) {
 return (
 <Card>
 <SH title={title} icon={icon} color={color} bg={bg}/>
 <div style={{overflowX:'auto'}}>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead>
 <tr style={{background:'#F5F8F5'}}>
 <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'left',borderBottom:`1px solid ${C.border}`}}>Description</th>
 {isRoom&&<><th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'center',borderBottom:`1px solid ${C.border}`,whiteSpace:'nowrap'}}>Min Tariff</th><th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'center',borderBottom:`1px solid ${C.border}`,whiteSpace:'nowrap'}}>Max Tariff</th></>}
 <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'center',borderBottom:`1px solid ${C.border}`}}>CGST %</th>
 <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'center',borderBottom:`1px solid ${C.border}`}}>SGST %</th>
 <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'center',borderBottom:`1px solid ${C.border}`}}>IGST %</th>
 <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'center',borderBottom:`1px solid ${C.border}`}}>Total GST</th>
 <th style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase',letterSpacing:'.06em',textAlign:'left',borderBottom:`1px solid ${C.border}`}}>Note</th>
 </tr>
 </thead>
 <tbody>
 {rows.map((row,i)=>{
 const total = row.cgst+row.sgst;
 const totalColor = total===0?C.text3:total<=6?C.accent:total<=12?C.blue:total<=18?C.amber:C.red;
 return (
 <tr key={row.id} style={{borderBottom:`1px solid ${C.border}`,background:i%2===0?'#FAFCFA':C.surface}}>
 <td style={{padding:'12px 14px'}}>
 <div style={{fontSize:13,fontWeight:600,color:C.text}}>{row.label}</div>
 </td>
 {isRoom&&(
 <>
 <td style={{padding:'12px 14px',textAlign:'center'}}>
 <div style={{display:'flex',alignItems:'center',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:7,overflow:'hidden',width:90,margin:'auto'}}>
 <span style={{padding:'6px 6px',fontSize:10,color:C.text3,borderRight:`1px solid ${C.border}`}}>₹</span>
 <input type="number" value={row.minRate} onChange={e=>onUpdate(i,'minRate',Number(e.target.value))}
 style={{flex:1,padding:'6px 6px',border:'none',background:'transparent',fontSize:12,fontWeight:600,fontFamily:'Inter,sans-serif',outline:'none',textAlign:'center'}}/>
 </div>
 </td>
 <td style={{padding:'12px 14px',textAlign:'center'}}>
 <div style={{display:'flex',alignItems:'center',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:7,overflow:'hidden',width:90,margin:'auto'}}>
 <span style={{padding:'6px 6px',fontSize:10,color:C.text3,borderRight:`1px solid ${C.border}`}}>₹</span>
 <input type="number" value={row.maxRate===999999?'':row.maxRate} onChange={e=>onUpdate(i,'maxRate',Number(e.target.value)||999999)}
 style={{flex:1,padding:'6px 6px',border:'none',background:'transparent',fontSize:12,fontWeight:600,fontFamily:'Inter,sans-serif',outline:'none',textAlign:'center'}}/>
 </div>
 </td>
 </>
 )}
 <td style={{padding:'12px 14px',textAlign:'center'}}><GSTInput value={row.cgst} onChange={v=>onUpdate(i,'cgst',v)} label=""/></td>
 <td style={{padding:'12px 14px',textAlign:'center'}}><GSTInput value={row.sgst} onChange={v=>onUpdate(i,'sgst',v)} label=""/></td>
 <td style={{padding:'12px 14px',textAlign:'center'}}><GSTInput value={row.igst} onChange={v=>onUpdate(i,'igst',v)} label=""/></td>
 <td style={{padding:'12px 14px',textAlign:'center'}}>
 <span style={{padding:'4px 12px',borderRadius:99,fontSize:13,fontWeight:800,color:totalColor,background:total===0?C.border:total<=6?C.accentLight:total<=12?C.blueBg:total<=18?C.amberBg:C.redBg,fontFamily:'Plus Jakarta Sans,sans-serif'}}>
 {total}%
 </span>
 </td>
 <td style={{padding:'12px 14px'}}>
 <input value={row.note} onChange={e=>onUpdate(i,'note',e.target.value)}
 style={{width:'100%',padding:'6px 8px',border:`1px solid ${C.border2}`,borderRadius:7,fontSize:12,fontFamily:'Inter,sans-serif',outline:'none',background:C.bg,color:C.text3}}/>
 </td>
 </tr>
 );
 })}
 </tbody>
 </table>
 </div>
 </Card>
 );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
const TABS = [
 {id:'calculator', label:'GST Calculator', },
 {id:'rooms', label:'Room GST Slabs', },
 {id:'fnb', label:'F&B Rates', },
 {id:'events', label:'Events & Packages',},
 {id:'activities', label:'Activities', },
 {id:'misc', label:'Miscellaneous', },
 {id:'reference', label:'GST Reference', },
];

export default function GSTConfig() {
 const [tab, setTab] = useState('calculator');
 const [config, setConfig] = useState(() => {
 try { const s=localStorage.getItem('botanix_gst'); return s?JSON.parse(s):DEFAULT_GST_CONFIG; } catch { return DEFAULT_GST_CONFIG; }
 });
 const [hasChanges, setHasChanges] = useState(false);
 const [showToast, setShowToast] = useState(false);

 const updateSection = (section, idx, field, value) => {
 setConfig(p => {
 const n = {...p, [section]:[...p[section]]};
 n[section][idx] = {...n[section][idx], [field]:value};
 // Auto-sync IGST = CGST + SGST for intra-state
 if(field==='cgst'||field==='sgst') n[section][idx].igst = n[section][idx].cgst + n[section][idx].sgst;
 return n;
 });
 setHasChanges(true);
 };

 const save = () => {
 try { localStorage.setItem('botanix_gst', JSON.stringify(config)); } catch {}
 setHasChanges(false);
 setShowToast(true);
 setTimeout(()=>setShowToast(false),3000);
 };

 const reset = () => {
 if(window.confirm('Reset all GST rates to Indian government defaults?')) {
 setConfig(DEFAULT_GST_CONFIG);
 setHasChanges(true);
 }
 };

 return (
 <div style={{fontFamily:'Inter,sans-serif',color:C.text}}>
 <SaveToast visible={showToast}/>

 {/* Top Bar */}
 <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:'0 28px',position:'sticky',top:0,zIndex:50}}>
 <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',height:62}}>
 <div>
 <div style={{fontSize:11,color:C.text3,fontWeight:500,marginBottom:1}}>Accounts — Tax Configuration</div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:20,fontWeight:800,color:C.text,letterSpacing:'-.02em'}}>GST Rate Configuration</div>
 </div>
 <div style={{display:'flex',gap:10,alignItems:'center'}}>
 {hasChanges&&(
 <div style={{display:'flex',alignItems:'center',gap:6,padding:'6px 12px',background:C.amberBg,border:`1px solid ${C.amberBorder}`,borderRadius:8}}>
 <span style={{width:7,height:7,borderRadius:'50%',background:C.amber}}/>
 <span style={{fontSize:12,fontWeight:600,color:C.amber}}>Unsaved changes</span>
 </div>
 )}
 <Btn variant="ghost" onClick={reset}>↺ Reset to Defaults</Btn>
 <Btn onClick={save} disabled={!hasChanges}> Save GST Rates</Btn>
 </div>
 </div>

 {/* Alert bar */}
 <div style={{background:'#FEF6E7',border:`1px solid ${C.amberBorder}`,borderRadius:8,padding:'8px 16px',marginBottom:8,display:'flex',alignItems:'center',gap:10}}>
 <span style={{fontSize:16}}></span>
 <span style={{fontSize:12,color:C.amber,fontWeight:500}}>
 These rates apply to all invoices generated in the system. Always verify with your CA before changing GST rates. Current rates as per Indian GST Act (effective July 2019, hospitality sector).
 </span>
 </div>

 <div style={{display:'flex',gap:0,overflowX:'auto'}}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{padding:'10px 16px',background:'transparent',border:'none',cursor:'pointer',fontSize:13,fontWeight:600,color:tab===t.id?C.accent:C.text3,borderBottom:`2px solid ${tab===t.id?C.accent:'transparent'}`,whiteSpace:'nowrap',display:'flex',alignItems:'center',gap:6}}>
 {t.icon} {t.label}
 </button>
 ))}
 </div>
 </div>

 <div style={{padding:'24px 28px'}}>

 {tab==='calculator' && <GSTCalculator config={config}/>}

 {tab==='rooms' && (
 <div style={{display:'flex',flexDirection:'column',gap:16}}>
 <div style={{padding:'16px 20px',background:C.blueBg,border:`1px solid ${C.blueBorder}`,borderRadius:10,fontSize:13,color:C.blue}}>
 <strong>Room GST Slabs (India, w.e.f. 1st July 2019):</strong> GST is charged based on the <em>declared tariff</em> (not the discounted price). The slab is determined by the room's published rate.
 </div>
 <RateTable
 title="Room Tariff GST Slabs" icon="" color={C.blue} bg={C.blueBg}
 rows={config.rooms} isRoom={true}
 onUpdate={(i,f,v)=>updateSection('rooms',i,f,v)}
 />
 {/* Room GST Quick Guide */}
 <Card style={{padding:20}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:14,fontWeight:800,color:C.text,marginBottom:14}}> Room GST Quick Reference</div>
 <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
 {config.rooms.map(r=>{
 const total = r.cgst+r.sgst;
 const color = total===0?C.text3:total<=12?C.blue:C.red;
 const bg = total===0?C.border:total<=12?C.blueBg:C.redBg;
 return (
 <div key={r.id} style={{padding:'16px',background:bg,borderRadius:10,border:`1px solid ${color}33`}}>
 <div style={{fontSize:11,fontWeight:700,color:C.text3,marginBottom:6,textTransform:'uppercase',letterSpacing:'.05em'}}>
 {r.minRate===0?'Below ₹1,000':r.maxRate===999999?'₹'+r.minRate.toLocaleString('en-IN')+'+ per night':'₹'+r.minRate.toLocaleString('en-IN')+' – ₹'+r.maxRate.toLocaleString('en-IN')}
 </div>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:32,fontWeight:800,color,marginBottom:4}}>{total}%</div>
 <div style={{fontSize:12,color:C.text3}}>CGST {r.cgst}% + SGST {r.sgst}%</div>
 <div style={{fontSize:11,color:C.text3,marginTop:4}}>{r.note}</div>
 </div>
 );
 })}
 </div>
 </Card>
 </div>
 )}

 {tab==='fnb' && <RateTable title="F&B / Restaurant GST Rates" icon="" color={C.accent} bg={C.accentLight} rows={config.fnb} onUpdate={(i,f,v)=>updateSection('fnb',i,f,v)}/>}
 {tab==='events' && <RateTable title="Events, Packages & Venue GST Rates" icon="" color={C.purple} bg={C.purpleBg} rows={config.events} onUpdate={(i,f,v)=>updateSection('events',i,f,v)}/>}
 {tab==='activities' && <RateTable title="Activities & Services GST Rates" icon="" color={C.red} bg={C.redBg} rows={config.activities} onUpdate={(i,f,v)=>updateSection('activities',i,f,v)}/>}
 {tab==='misc' && <RateTable title="Miscellaneous GST Rates" icon="" color={C.teal} bg={C.tealBg} rows={config.misc} onUpdate={(i,f,v)=>updateSection('misc',i,f,v)}/>}

 {tab==='reference' && (
 <div style={{display:'flex',flexDirection:'column',gap:16}}>
 <Card style={{padding:22}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:16,fontWeight:800,color:C.text,marginBottom:20}}> Complete Indian GST Reference — Hotel & Hospitality Sector</div>
 <table style={{width:'100%',borderCollapse:'collapse'}}>
 <thead>
 <tr style={{background:'#1A2E1E'}}>
 {['Service','Condition / Threshold','GST Rate','SAC Code','Notes'].map(h=>(
 <th key={h} style={{padding:'10px 14px',fontSize:11,fontWeight:700,color:'rgba(255,255,255,.8)',textTransform:'uppercase',letterSpacing:'.05em',textAlign:'left'}}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {[
 ['Hotel Room','Tariff < ₹1,000/night','0% (Exempt)','996311','No GST, no ITC'],
 ['Hotel Room','Tariff ₹1,000–₹7,499/night','12% (6+6)','996311','ITC available'],
 ['Hotel Room','Tariff ₹7,500+/night','18% (9+9)','996311','ITC available'],
 ['Restaurant','AC restaurant','5% (2.5+2.5)','996333','No ITC'],
 ['Restaurant','Non-AC restaurant','5% (2.5+2.5)','996333','No ITC'],
 ['F&B','Outdoor catering/banquet','18% (9+9)','996334','ITC available'],
 ['Alcohol','All alcoholic beverages','28% (14+14)','996329','State-level also applies'],
 ['Venue','Banquet / function hall','18% (9+9)','996311','ITC available'],
 ['Package','Corporate day outing','18% (9+9)','996311','Composite supply'],
 ['Package','School picnic','5% (2.5+2.5)','996311','Educational'],
 ['Package','Wedding package','18% (9+9)','996311','Composite supply'],
 ['Conference','MICE / conference','18% (9+9)','996311','ITC available'],
 ['Activity','Adventure sports','18% (9+9)','996319','ITC available'],
 ['Laundry','Laundry services','18% (9+9)','996311','ITC available'],
 ['Transport','Vehicle hire','5% (2.5+2.5)','996601','No ITC'],
 ['Spa','Spa / wellness','18% (9+9)','999723','ITC available'],
 ].map(([svc,cond,rate,sac,note],i)=>(
 <tr key={i} style={{borderBottom:`1px solid ${C.border}`,background:i%2===0?'#FAFCFA':C.surface}}>
 <td style={{padding:'11px 14px',fontWeight:600,fontSize:13}}>{svc}</td>
 <td style={{padding:'11px 14px',fontSize:12,color:C.text2}}>{cond}</td>
 <td style={{padding:'11px 14px'}}>
 <span style={{padding:'3px 10px',borderRadius:99,fontSize:12,fontWeight:700,
 color:rate==='0% (Exempt)'?C.text3:rate.startsWith('5')?C.accent:rate.startsWith('12')?C.blue:rate.startsWith('18')?C.amber:C.red,
 background:rate==='0% (Exempt)'?C.border:rate.startsWith('5')?C.accentLight:rate.startsWith('12')?C.blueBg:rate.startsWith('18')?C.amberBg:C.redBg,
 fontFamily:'Plus Jakarta Sans,sans-serif'}}>
 {rate}
 </span>
 </td>
 <td style={{padding:'11px 14px',fontFamily:'monospace',fontSize:12,color:C.text3}}>{sac}</td>
 <td style={{padding:'11px 14px',fontSize:12,color:C.text3}}>{note}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </Card>

 <Card style={{padding:20,background:`linear-gradient(135deg,${C.dark},#1A3A22)`,border:'none'}}>
 <div style={{color:'rgba(255,255,255,.5)',fontSize:12,lineHeight:1.7}}>
 <div style={{fontFamily:'Plus Jakarta Sans,sans-serif',fontSize:15,fontWeight:700,color:'#fff',marginBottom:10}}> Important Legal Notes</div>
 <div>• GST rates for rooms are determined by the <strong style={{color:'rgba(255,255,255,.85)'}}>declared tariff</strong>, not the charged/discounted rate</div>
 <div>• Intra-state transactions: CGST + SGST applies. Inter-state: IGST applies</div>
 <div>• Composite supply (e.g. room + meals): GST rate of principal supply applies to whole package</div>
 <div>• Mixed supply: highest GST rate among components applies</div>
 <div>• B2B invoices require customer GSTIN for Input Tax Credit (ITC)</div>
 <div>• GSTR-1 filing due: 11th of following month (for monthly filers)</div>
 <div>• GSTR-3B filing due: 20th of following month</div>
 <div style={{marginTop:10,padding:'10px 12px',background:'rgba(231,76,60,.15)',borderRadius:8,border:'1px solid rgba(231,76,60,.3)',color:'#FF8080'}}>
 Always consult your CA / tax advisor before changing GST rates. Rates are subject to change by GST Council notifications.
 </div>
 </div>
 </Card>
 </div>
 )}

 {/* Bottom save bar */}
 {hasChanges && (
 <div style={{position:'sticky',bottom:20,marginTop:20,background:C.text,borderRadius:12,padding:'14px 20px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 8px 32px rgba(0,0,0,.2)'}}>
 <div style={{color:'#fff',fontSize:13}}>You have unsaved GST rate changes — save before generating new invoices.</div>
 <div style={{display:'flex',gap:10}}>
 <Btn variant="ghost" onClick={()=>{setConfig(DEFAULT_GST_CONFIG);setHasChanges(false);}} style={{color:'#fff',borderColor:'rgba(255,255,255,.3)'}}>Discard</Btn>
 <Btn onClick={save}> Save GST Rates</Btn>
 </div>
 </div>
 )}
 </div>
 </div>
 );
}
